/**
 * Thin wrapper around window.location navigation.
 * Extracted as a named export so it can be spied on in tests,
 * since jsdom does not support direct reassignment of window.location.href.
 */
export const navigateTo = (url: string): void => {
  // TODO(WPIP-81779): refactor `location` usage to use `locator`.
  window.location.href = url;
};

export const redirectToLogin = () => {
  navigateTo(
    '/ecom/login?redirect=' + encodeURIComponent(window.location.pathname + window.location.search),
  );
};
